// Configuration
const CONFIG = {
    maxRetries: 10,
    retryDelay: 500
};

// State tracking
let observer;
let retryCount = 0;
let isInitialized = false;

// Wait for both DOM and critical elements
function waitForElement(selector, timeout = 10000) {
    return new Promise((resolve, reject) => {
        const element = document.querySelector(selector);
        if (element) {
            resolve(element);
            return;
        }

        const startTime = Date.now();
        const checkInterval = setInterval(() => {
            const element = document.querySelector(selector);
            if (element) {
                clearInterval(checkInterval);
                resolve(element);
            } else if (Date.now() - startTime > timeout) {
                clearInterval(checkInterval);
                reject(new Error(`Element ${selector} not found within ${timeout}ms`));
            }
        }, 100);
    });
}

function legendSelector(name) {
    return `.globo-swatch-list legend[data-name*="${name}" i]`;
}

const swatchSelector = '.globo-swatch-list ul:not(.ul-swatches-list)';

function updateCurrentPrice(li) {
    const colorLegend = document.querySelector(legendSelector('color')) ? 'color' : 'colour';
    const colorInput = document.querySelector(`${legendSelector(colorLegend)} ~ ul.value li input:checked`);
    const sizeInput = document.querySelector(`${legendSelector('size')} ~ ul.value li input:checked`);
    const materialInput = document.querySelector(`${legendSelector('material')} ~ ul.value li input:checked`);

    const color = colorInput ? colorInput.value : null;
    const size = sizeInput ? sizeInput.value : null;
    const material = materialInput ? materialInput.value : null;

    const publicTitle = material ? (`${material} / ${color}`)
        : (size ?
            (color ? (`${color} / ${size}`) : size)
            : color);

    const variant = meta.product.variants.find(function (v) {
        return v.public_title === publicTitle;
    });

    const price = variant ? variant.price : null;
    const convertedPrice = DoublyGlobalCurrency.convert(
        price,
        'AED',
        DoublyGlobalCurrency.currentCurrency
    );
    const formattedPrice = DoublyGlobalCurrency.formatMoney(
        convertedPrice,
        DoublyGlobalCurrency.moneyFormats[DoublyGlobalCurrency.currentCurrency][DoublyGlobalCurrency.format]
    );

    const span = document.createElement('span');
    span.className = 'money';
    span.setAttribute('doubly-currency-aed', price);
    span.setAttribute('doubly-currency', 'AED');
    span.textContent = formattedPrice;
    const currentPriceBdi = document.querySelector('.product__info-container--sticky .price--small bdi');
    const regularPriceSpan = document.querySelector('.product__title .price__regular .price-item--regular');
    const salePriceSpan = document.querySelector('.product__title .price__sale .price-item--sale');
    currentPriceBdi && (currentPriceBdi.innerHTML = span.cloneNode(true).outerHTML);
    regularPriceSpan && (regularPriceSpan.innerHTML = span.cloneNode(true).outerHTML);
    salePriceSpan && (salePriceSpan.innerHTML = span.cloneNode(true).outerHTML);

    // debounce to avoid rapid repeated clicks
    clearTimeout(updateCurrentPrice.timeout);
    updateCurrentPrice.timeout = setTimeout(() => {
        let colorLi = colorInput ? colorInput.closest('li') : null;
        let sizeLi = sizeInput ? sizeInput.closest('li') : null;

        const colorLiOut = colorLi && colorLi.classList.contains('globo-out-of-stock');
        const sizeLiOut = sizeLi && sizeLi.classList.contains('globo-out-of-stock');

        const ul = li.closest('ul.value');
        const isMaterialSwatch = !!(ul.previousElementSibling && ul.previousElementSibling.matches(legendSelector('material')));
        if (isMaterialSwatch && (colorLiOut || sizeLiOut)) {
            colorLi = document.querySelector(`${legendSelector(colorLegend)} ~ ul.value > li:not(.globo-out-of-stock) input`);
            sizeLi = document.querySelector(`${legendSelector('size')} ~ ul.value > li:not(.globo-out-of-stock) input`);
            const targetLi = colorLi || sizeLi;
            if (targetLi) {
                targetLi.click();
            }
        }
    }, 100);
}

// Enhanced observer setup
function setupSwatchObserver() {
    // Disconnect existing observer
    if (observer) {
        observer.disconnect();
    }

    observer = new MutationObserver((mutations) => {
        if (!document.querySelector(swatchSelector)) return;

        // Use debouncing to avoid excessive processing
        clearTimeout(observer.timeout);
        observer.timeout = setTimeout(() => {
            document.querySelectorAll('.globo-swatch-product-detail .swatch--gl .select-option input[type="radio"]').forEach(input => {
                const li = input.closest('li');
                input.addEventListener('change', (evt) => {
                    updateCurrentPrice(li);
                });
            });
        }, 100);
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style']
    });
}

// Enhanced initialization with retry logic
async function initializePriceFix() {
    if (isInitialized) return;

    try {
        // Wait for critical elements
        await waitForElement('body');

        // Setup observer for swatch changes
        setupSwatchObserver();

        isInitialized = true;
        console.log('Price fix initialized successfully');

    } catch (error) {
        console.warn('Initialization failed, retrying...', error);
        retryCount++;

        if (retryCount < CONFIG.maxRetries) {
            setTimeout(() => initializePriceFix(), CONFIG.retryDelay);
        } else {
            console.error('Max retries reached, giving up');
        }
    }
}

// Start initialization when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializePriceFix);
} else {
    initializePriceFix();
}

// Also initialize if swatches load later
// document.addEventListener('shopify:section:load', initializePriceFix);
window.addEventListener('Globo.swatch.loaded', initializePriceFix);